import { render, staticRenderFns } from "./DeclineChipRequestDialog.vue?vue&type=template&id=edfbdcf2&lang=pug&"
import script from "./DeclineChipRequestDialog.vue?vue&type=script&lang=js&"
export * from "./DeclineChipRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports